<template>
    <div>        
        <div class="p-1">
            <div class="d-flex justify-content-between bg-white p-3 mb-3">
                <div class="small">
                    Halo, {{ account.username }} <br>
                    Apa ada yang baru?
                </div>
                <div class="mt-2" role="button" @click="openDialog = !openDialog">
                    <box-icon name="plus-circle"></box-icon>
                </div>
            </div>

            <!-- Main Content -->
            <template v-if="posts">
                <vs-card v-for="post in posts" :key="post.id" class="mb-3">
                    <template #img>
                        <img :src="post.urlImage">
                    </template>
                    <template #text>
                        <div class="mt-2">                        
                            <div class="font-weight-bold">@{{ post.username }}</div>
                            <div class="mt-1">{{ post.title }}</div>
                            <div class="text-right small">{{ convertToDate(post.created_at) }}</div>
                        </div>
                    </template>
                    <template #interactions>
                        <vs-button class="btn-chat" shadow primary @click="openCommentSection(post.id)">
                            <box-icon name="chat"></box-icon>
                            <span class="span ml-2">
                                {{ post.comments ? post.comments.length : '0' }}
                            </span>
                        </vs-button>
                    </template>
                </vs-card>
            </template>
            <template v-else>
                <div class="text-center mt-3 p-3">Belum ada Postingan apapun, Yu buat postingan biar seru..</div>
            </template>
            <!-- End -->
        </div>

        <!-- Open Comments -->
        <vue-bottom-sheet ref="openComments" max-height="70%" :is-full-screen="true">
            <div class="d-flex justify-content-between p-2">
                <div>
                    <vs-input border placeholder="Beri Komentar" v-model="comment" @keyup.enter="saveComment()"/>
                </div>
                <div class="mt-2">
                    <vs-button icon shadow color="#7d33ff" @click="saveComment()">
                        <box-icon name="send"></box-icon>
                    </vs-button>
                </div>
            </div>
            <div class="d-flfex justify-content-center">
                <template v-if="selected_post.comments.length > 0">
                    <div class="border-bottom p-3" v-for="comment in selected_post.comments" :key="comment.id">
                        <div class="bold small">@{{ comment.username }}</div>
                        <div class="small text-muted">{{ comment.comment }}</div>
                        <div class="small text-muted text-right mt-3">{{ convertToDate(comment.created_at) }}</div>
                    </div>
                </template>
                <template v-else>
                    <div class="text-center mt-3">
                        Belum ada komentar apapun
                    </div>
                </template>
            </div>
        </vue-bottom-sheet>
        <!-- End -->

        <!-- Dialog Post -->
        <vs-dialog v-model="openDialog" overflow-hidden :prevent-close="loading.post" :not-close="loading.post">
            <div class="p-3">
                <h6>Buat Postingan Baru</h6>
                <div class="dropdown-divider"></div>
                <input type="file" class="d-none" ref="fileInput" @change="fileInput" accept="image/*">

                <div class="text-center" :class="{'bg-light p-5' : !post.file && !post.preview}" role="button" @click="$refs.fileInput.click()">
                    <template v-if="post.file && post.preview">
                        <img :src="post.preview" class="w-100 mt-2">
                    </template>
                    <template v-else>
                        <div>Pilih Foto</div>
                        <div><box-icon name="upload"></box-icon></div>
                    </template>
                </div>

                <div class="mt-3 mb-0" v-if="post.file && post.preview">
                    <vs-input border v-model="post.title" placeholder="Judul postingan"/>
                    <div class="mt-3">
                        <vs-button block @click="postPublish()" :loading="loading.post">Posting</vs-button>
                    </div>
                </div>
            </div>
        </vs-dialog>
        <!-- End -->
    </div>
</template>

<script>
import VueBottomSheet from '@webzlodimir/vue-bottom-sheet';
import accountHelper from '@/helpers/account';
import { dbRealtime } from '@/helpers/firebase';
import firebase from 'firebase';
import moment from 'moment';

export default {
    data() {
        return {
            openDialog: false,
            selected_post: {
                comments: [],
            },
            posts: {},
            post: {
                file: '',
                preview: '',
                title: '',
                urlImage: '',
            },
            comment: '',
            
            loading: {
                post: false,
            },
        }
    },
    methods: {
        // Posts
        getPosts() {
            dbRealtime.ref('/posts').on('value', snapshot => {
                this.posts = snapshot.val();
            });
        },
        getOnePost(key) {
            dbRealtime.ref('posts/'+key).on('value', snapshot => {
                let post = snapshot.val();
                    post.comments = post.comments ? post.comments : [];
                this.selected_post = post;
            });
        },
        openCommentSection(key) {
            this.$refs.openComments.open();
            this.getOnePost(key);
        },
        saveComment() {
            if(this.comment) {
                let comment = {
                    comment: this.comment,
                    username: this.account.username,
                    created_at: Date.now(),
                };

                this.selected_post.comments.push(comment);

                dbRealtime.ref('posts/'+this.selected_post.id).set(this.selected_post);

                this.comment = '';
            }
        },
        // End

        // Utility function
        uniqid(length) {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            return result;
        },
        convertToDate(date) {
            return moment(date).format('DD MMMM YYYY - HH:mm');
        },
        showNotification({icon, position, title, text}) {
            this.$vs.notification({
                icon: icon,
                progress: 'auto',
                position: position,
                title: title,
                text: text,
            });
        },
        // End

        // Function for Publish Post
        fileInput(event) {
            if(event) {
                let file = event.target.files[0];
                if(file) {
                    this.post.file = file;
                    this.post.preview = URL.createObjectURL(file);
                } else {
                    this.post.file = '';
                    this.post.preview = '';
                }
            } else {
                this.post.file = '';
                this.post.preview = '';
            }
        },
        postPublish() {
            let post = this.post;

            if(post.file && post.preview && post.title) {
                this.uploadImage(post.file);
                this.loading.post = true;
            }
        },
        async postSave(post) {
            delete post.file;
            delete post.preview;

            let uid = this.uniqid(20);

            post.comments = [];
            post.created_at = Date.now();
            post.username = this.account.username;
            post.email = this.account.email;
            post.id = uid;

            await dbRealtime.ref('/posts/'+uid).set(post);

            let notif = {
                icon: '<box-icon name="bell"></box-icon>',
                position: 'bottom-center',
                title: 'Yeayyyy...',
                text: 'Postingan berhasil di publish',
            }
            this.showNotification(notif);

            this.resetPost();
            this.loading.post = false;
            this.openDialog = false;
            this.getPosts();
        },
        async uploadImage(file) {
            let storageRef = firebase.storage().ref('post/');
            let rand = Math.floor(1000  + Math.random() * 9000000);

            await storageRef.child('POST_'+rand).put(file).then(snapshot => {
                snapshot.ref.getDownloadURL().then(url => {
                    this.post.urlImage = url;
                    this.postSave(this.post);
                });
            });
        },
        resetPost() {
            this.post = {
                file: '',
                preview: '',
                title: '',
                urlImage: '',
            };
        },
        // End
    },
    components: {
        'vue-bottom-sheet': VueBottomSheet,
    },
    computed: {
        account() {
            return accountHelper.getIdUser();
        }
    },
    mounted() {
        this.getPosts();
    }
}
</script>